import ReactDOM from "react-dom";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { Button, IconButton } from "@common-ui/ui";
import CloseIcon from "@mui/icons-material/Close";
import { ModalContext } from "./modalContext";
import React from "react";
export default function BrowserAlert() {
  let { modalTitle, modalContent, handleModal, modal } =
    React.useContext(ModalContext);
  if (modal) {
    return ReactDOM.createPortal(
      <Dialog
        open={modal}
        fullWidth
        onClose={handleModal}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {modalTitle}
          {modal ? (
            <IconButton
              aria-label="close"
              onClick={handleModal}
              sx={{
                position: "absolute",
                right: 8,
                top: 8,
                color: (theme) => theme.palette.grey[500],
              }}
            >
              <CloseIcon />
            </IconButton>
          ) : null}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {modalContent}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleModal} variant="contained">
            Close
          </Button>
        </DialogActions>
      </Dialog>,
      document.querySelector("#modal-root")
    );
  } else return null;
}

